(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('CpfLoginUnificadoCtrl', CpfLoginUnificadoCtrl);

  CpfLoginUnificadoCtrl.$inject = [
    'Flash',
    'UsuariosService',
    '$uibModalInstance',
    '$rootScope',
    'CPF_MASK'
  ];
  // eslint-disable-next-line max-lines-per-function, max-params
  function CpfLoginUnificadoCtrl(Flash, UsuariosService, $uibModalInstance, $rootScope, CPF_MASK) {
    const vm = this;
    vm.CPF_MASK = CPF_MASK;

    vm.usuario = {};
    vm.erroCPFLoginUnificado = null;
    vm.loading = false;

    vm.close = $uibModalInstance.dismiss;

    vm.resetErrors = function() {
      vm.erroCPFLoginUnificado = null;
    };

    vm.cadastrarLoginUnificado = function(form) {
      vm.resetErrors();
      if (form.$invalid) {
        return;
      }

      const usuario = {
        id: $rootScope.currentUser.id,
        cpf: vm.usuario.cpf
      };
      vm.loading = true;
      UsuariosService.cadastrarLoginUnificado(usuario).then(function() {
        $uibModalInstance.dismiss();
        Flash.create(REGISTRO_SALVO_COM_SUCESSO.type, 'CPF cadastrado com sucesso!');
      }, function(error) {
        if ((error.data || {}).cpf) {
          vm.erroCPFLoginUnificado = error.data.cpf;
        } else {
          vm.erroCPFLoginUnificado = [
            'Falha ao enviar CPF, tente novamente mais tarde.'
          ];
        }
      })
        .finally(() => vm.loading = false);
    };
  }
}());
